<template>
  <div class="rules_content" v-if="rules && rules.length">
    <div v-for="(item, index) in rules" :key="index" class="rules_item">
      <div v-if="item.type == 'text'" class="text">{{ item.value }}</div>
      <img
        :src="item.value"
        v-if="item.type == 'img'"
        class="img"
        @click.stop="previewImage(item.value)"
      />
      <video
        :src="item.url_play"
        class="videos-item"
        controls="controls"
        :poster="item.url"
        v-if="item.type == 'video'"
      ></video>
      <div
        v-if="item.type == 'file'"
        class="file-item position-r"
        @click.stop="openItem(item)"
      >
        <div :style="{ background: getFileType(item.value, 1) }" class="type">
          {{ getFileType(item.value) }}
        </div>
        <div class="name">
          {{ item.desc }}
        </div>
        <div v-if="!item.status" class="download-part">
          <img
            alt=""
            class="download-icon"
            src="https://cdn-xcx-qunsou.weiyoubot.cn/material/2024-10-16/7f3961adc0a00f0553be78b291ab1baa.png"
          />
        </div>
        <WxLink
          v-if="isWeixin && isMobile && item.status"
          :wxPath="wxPath + qid"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { ImagePreview } from "vant";
import WxLink from "@/components/wxLink.vue";

export default {
  props: ["rules", "qid", "isWeixin", "isMobile"],
  components: { WxLink },
  data() {
    return {
      wxPath: "/pages/detail/detail?qid="
    };
  },
  methods: {
    openItem(item) {
      this.$emit("handleRules", item);
    },
    getFileType(file, way) {
      let str = file;
      let type = "F";
      let bg_color = "#1890ff";
      if (
        str.indexOf("docx") !== -1 ||
        str.indexOf("DOCX") !== -1 ||
        str.indexOf("doc") !== -1 ||
        str.indexOf("DOC") !== -1
      ) {
        type = "DOC";
        bg_color = "#1890FF";
      }
      if (
        str.indexOf("xlsx") !== -1 ||
        str.indexOf("XLSX") !== -1 ||
        str.indexOf("xls") !== -1 ||
        str.indexOf("XLS") !== -1
      ) {
        type = "XLS";
        bg_color = "#34C759";
      }
      if (
        str.indexOf("pptx") !== -1 ||
        str.indexOf("PPTX") !== -1 ||
        str.indexOf("ppt") !== -1 ||
        str.indexOf("PPT") !== -1
      ) {
        type = "PPT";
        bg_color = "#F34E19";
      }
      if (str.indexOf("TXT") !== -1 || str.indexOf("txt") !== -1) {
        type = "TXT";
        bg_color = "#FCCC5A";
      }
      if (str.indexOf("pdf") !== -1 || str.indexOf("PDF") !== -1) {
        type = "PDF";
        bg_color = "#FF7875";
      }
      if (str.indexOf("rar") !== -1 || str.indexOf("RAR") !== -1) {
        type = "rar";
      }
      if (way) {
        return bg_color;
      } else {
        return type;
      }
    },
    getImages() {
      return arr;
    },
    previewImage(value) {
      let arr = [];
      this.rules.map(item => {
        if (item.type === "img") {
          arr.push(item.value);
        }
      });
      ImagePreview({
        images: arr,
        closeable: true,
        startPosition: arr.indexOf(value)
      });
    }
  }
};
</script>
<style scoped lang="scss">
.rules_content {
  font-size: 14px;
  color: #262626;
  background: #fff;
  padding: 15px;
  margin-top: 10px;
  .rules_item {
    margin-top: 15px;
  }
  .rules_item:first-child {
    margin-top: 0;
  }
  .text {
    white-space: break-spaces;
    word-break: break-all;
    line-height: 23px;
  }
  img {
    width: 100%;
    object-fit: cover;
  }
  .videos-item {
    width: 100%;
    height: 200px;
  }
}
.file-item {
  background-color: #f2f2f7;
  padding: 16px 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .type {
    width: 32px;
    height: 32px;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-size: 12px;
    border-radius: 4px;
    margin-right: 8px;
    font-weight: bold;
  }
  .name {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    cursor: pointer;
  }
  .download-icon {
    width: 14px;
    height: 14px;
    margin-left: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/detail/workcontent.vue